import { useLocation } from "react-router-dom";
import t from "utils/translate";
import coupon from "../CouponCode/imgs/coupon.svg";
import close from "./imgs/close.svg";

import styles from "./styles.module.scss";

const CouponCodeTag = ({ onChange, data, setPlan, setDiscount }) => {
  const location = useLocation();

  const removeCouponCode = e => {
    e.preventDefault();
    setPlan(location.state?.plan);
    setDiscount({
      discount: "",
      total: "",
      terms: ""
    });
    onChange("couponCode", "");
  };

  return (
    <div className={styles.couponCodeTag} data-testid="coupon-code-tag">
      <img width="20" height="20" alt="" src={coupon} />
      <span>{data.couponCode}</span>
      <button
        type="button"
        onClick={removeCouponCode}
        className={styles.close}
        aria-label={t("COUPON_CODE_REMOVE")}
        da-category="quiz"
        da-label="quiz:remove_coupon_code"
        da-action="remove_coupon_code"
      >
        <img width="10" height="10" alt="" src={close} />
      </button>
    </div>
  );
};

export default CouponCodeTag;
